
import React, { useState, useEffect } from 'react';

interface LoginFormProps {
  onLogin: (user: string, pass: string) => void;
  isLoading: boolean;
  error: string | null;
}

const LoginForm: React.FC<LoginFormProps> = ({ onLogin, isLoading, error }) => {
  const [user, setUser] = useState('');
  const [pass, setPass] = useState('');
  const [time, setTime] = useState(new Date());

  useEffect(() => {
    const timer = setInterval(() => setTime(new Date()), 1000);
    return () => clearInterval(timer);
  }, []);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onLogin(user, pass);
  };

  return (
    <div className="bg-white p-8 rounded-[2rem] shadow-2xl shadow-indigo-200/50 border border-indigo-50 w-full overflow-hidden relative">
      <div className="absolute top-0 left-0 w-full h-2 bg-gradient-to-r from-indigo-500 to-violet-500"></div>
      
      <div className="text-center mb-8 pt-4">
        <div className="w-20 h-20 bg-indigo-50 rounded-2xl flex items-center justify-center mx-auto mb-4 text-indigo-600 shadow-inner">
           <i className="fa-solid fa-graduation-cap text-3xl"></i>
        </div>
        <h2 className="text-xl font-black text-slate-800 tracking-tight">Login Admin</h2>
        <p className="text-xs font-bold text-slate-400 uppercase tracking-widest mt-1">
          {time.toLocaleTimeString('id-ID', {hour12: false})} WIB
        </p>
      </div>

      <form onSubmit={handleSubmit} className="space-y-4">
        <div className="bg-slate-50 rounded-xl px-4 py-3 border border-slate-100 focus-within:border-indigo-500 focus-within:ring-2 focus-within:ring-indigo-100 transition-all">
           <label className="block text-[10px] font-bold text-slate-400 uppercase">Username</label>
           <input 
              type="text" 
              value={user} 
              onChange={(e) => setUser(e.target.value)} 
              className="w-full bg-transparent border-none p-0 text-sm font-bold text-slate-700 focus:ring-0 placeholder-slate-300"
              placeholder="admin"
              required
           />
        </div>
        <div className="bg-slate-50 rounded-xl px-4 py-3 border border-slate-100 focus-within:border-indigo-500 focus-within:ring-2 focus-within:ring-indigo-100 transition-all">
           <label className="block text-[10px] font-bold text-slate-400 uppercase">Password</label>
           <input 
              type="password" 
              value={pass} 
              onChange={(e) => setPass(e.target.value)} 
              className="w-full bg-transparent border-none p-0 text-sm font-bold text-slate-700 focus:ring-0 placeholder-slate-300"
              placeholder="••••••"
              required
           />
        </div>

        {error && (
          <div className="text-[10px] font-bold text-rose-500 bg-rose-50 p-3 rounded-lg flex items-center gap-2">
             <i className="fa-solid fa-circle-exclamation"></i> {error}
          </div>
        )}

        <button 
          type="submit" 
          disabled={isLoading}
          className="w-full py-4 bg-indigo-600 hover:bg-indigo-700 text-white rounded-xl font-bold text-xs uppercase tracking-widest transition-all shadow-lg shadow-indigo-200 mt-2 flex items-center justify-center gap-2 disabled:opacity-70"
        >
          {isLoading ? <i className="fa-solid fa-spinner fa-spin"></i> : 'MASUK SISTEM'}
        </button>
      </form>
    </div>
  );
};

export default LoginForm;
